module.exports = __webpack_public_path__ + "img/weddings_05_V.8ce0fda2.webp";